import { resetAllAnalyticsFilterStores } from 'pages/ReportsPage/store/analyticsFilter.store';
import { payPeriodStore } from 'pages/ReportsPage/store/payPeriod.store';
import { reportsDataHealthStore } from 'pages/ReportsPage/store/reportsDataHealth.store';
import { fulfillmentDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/fulfillmentDashboard.store';
import { laborCostDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/store/laborCostDashboard.store';
import { overviewDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/store/overviewDashboard.store';
import { laborProductivityDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/store/laborProductivityDashboard.store';
import { overtimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/store/overtimeDashboard.store';
import { dailyOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/DailyOvertimeDashboard/store/dailyOvertimeDashboard.store';
import { employeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store';
import { agencyDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/AgencyDashboard/store/agencyDashboard.store';
import { patternLibraryStore } from 'pages/Schedule/store/patternLibrary.store';
import { scheduleLinesStore } from 'pages/Schedule/store/scheduleLines.store';
import { schedulesStore } from 'pages/Schedule/store/schedules.store';
import { organizationSkillsStore } from 'pages/Settings/pages/Organization/SkillsPage/store/organizationSkills.store';
import { locationSkillsStore } from 'pages/Settings/pages/LocationSettings/SkillsAllocation/store/locationSkills.store';
import { janeSkillAssignmentsStore } from 'modals/JaneDetailsModal/views/EditJaneView/store/janeSkillAssignments.store';

export const resetAllZustandStores = () => {
  resetAllAnalyticsFilterStores();
  payPeriodStore.getState().reset();
  reportsDataHealthStore.getState().reset();
  fulfillmentDashboardStore.getState().reset();
  laborCostDashboardStore.getState().reset();
  laborProductivityDashboardStore.getState().reset();
  overviewDashboardStore.getState().reset();
  overtimeDashboardStore.getState().reset();
  dailyOvertimeDashboardStore.getState().reset();
  employeeEngagementDashboardStore.getState().reset();
  agencyDashboardStore.getState().reset();
  patternLibraryStore.getState().reset();
  scheduleLinesStore.getState().reset();
  schedulesStore.getState().reset();
  locationSkillsStore.getState().reset();
  organizationSkillsStore.getState().reset();
  janeSkillAssignmentsStore.getState().reset();
};
